module.exports = __webpack_public_path__ + "img/td1.7f00b60a.png";